"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var antd_1 = require("antd");
/**
 * Input field for a numeric filter value.
 */
var NumberFilterField = /** @class */ (function (_super) {
    __extends(NumberFilterField, _super);
    function NumberFilterField(props) {
        var _this = _super.call(this, props) || this;
        /**
         * Stores the new value to the state object and
         * passes it to the passed in 'onValueChange' handler.
         */
        _this.onChange = function (e) {
            _this.setState({ value: e });
            _this.props.onValueChange(e);
        };
        _this.state = {
            value: _this.props.value
        };
        return _this;
    }
    NumberFilterField.getDerivedStateFromProps = function (nextProps, prevState) {
        return {
            value: nextProps.value
        };
    };
    NumberFilterField.prototype.render = function () {
        var _a = this.props, validateStatus = _a.validateStatus, help = _a.help, placeholder = _a.placeholder;
        var helpTxt = validateStatus !== 'success' ? help : null;
        return (React.createElement("div", { className: "gs-text-filter-fld", draggable: true, onDragStart: function (e) { return e.preventDefault(); } },
            React.createElement(antd_1.Form.Item, { label: this.props.label, colon: false, validateStatus: this.props.validateStatus, help: helpTxt, hasFeedback: true },
                React.createElement(antd_1.InputNumber, { defaultValue: this.state.value, value: this.state.value, style: {
                        width: '100%'
                    }, onChange: this.onChange, placeholder: placeholder }))));
    };
    NumberFilterField.defaultProps = {
        label: 'Value',
        placeholder: 'Enter Numeric Value',
        value: undefined,
        validateStatus: 'success',
        help: 'Please enter a number.'
    };
    return NumberFilterField;
}(React.Component));
exports.NumberFilterField = NumberFilterField;
exports.default = NumberFilterField;
//# sourceMappingURL=NumberFilterField.js.map